// Landing page for app.puttr.co deep links that have no web equivalent:
// /tournament/:id, /play/:gameId, /improve, /league (the monthly newsletter
// buttons). With the app installed the OS opens the app before this page
// loads (universal / app links, see public/.well-known and the app's
// DeepLinkHandler.js). Without it, this page tries the puttr:// scheme and
// then sends the player to the App Store / Google Play; on desktop it shows
// both store links.
import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { ReactComponent as Logo } from '../../images/logo_header.svg';
import { openInApp, isMobile, isAndroid, APP_STORE_URL, PLAY_STORE_URL } from './OpenInApp';

const COPY = {
  tournament: { title: 'This tournament lives in the Puttr app', body: 'Open the app to see the rounds, the leaderboard and the prize, then play your four rounds whenever you like.' },
  play: { title: 'This game lives in the Puttr app', body: 'Open the app and the game intro will be waiting for you.' },
  improve: { title: 'Your Putting Coach lives in the Puttr app', body: "Open the Improve tab for today's session, built from your last 30 days on the green." },
  versus: { title: 'Versus lives in the Puttr app', body: 'Open the app to challenge a friend head to head, or answer the challenges waiting in your inbox.' },
  league: { title: 'League Night lives in the Puttr app', body: 'Open the app for the standings, your team and this week\'s game.' },
};

export default function AppLink({ kind }) {
  const params = useParams();
  const location = useLocation();
  const path = location.pathname.replace(/^\//, ''); // 'tournament/162' etc.
  const copy = COPY[kind] || COPY.play;

  // No automatic puttr:// attempt: on iOS that pops a "open in Puttr?" dialog
  // on every visit. If the app is installed the OS has already opened it via
  // the universal / app link before this page loads; otherwise the button
  // below is the explicit way in, and the store link covers the rest.
  useEffect(() => {
    document.body.classList.add('dark');
    return () => document.body.classList.remove('dark');
  }, [path]);

  return (
    <div className="appLink">
      <Logo className="appLinkLogo" />
      <h1 className="appLinkTitle">{copy.title}</h1>
      <p className="appLinkBody">{copy.body}</p>
      {isMobile() ? (
        <>
          {/* An <a>, not a <button>: the app's global button styles (Bootstrap plus a few
              page stylesheets) otherwise squash it. */}
          <a className="appLinkBtn appLinkBtnPrimary" href={'puttr://' + path} onClick={(e) => { e.preventDefault(); openInApp(path); }}>Open in the Puttr app</a>
          <a className="appLinkStore" href={isAndroid() ? PLAY_STORE_URL : APP_STORE_URL}>
            Don't have it yet? Get Puttr on {isAndroid() ? 'Google Play' : 'the App Store'}
          </a>
        </>
      ) : (
        <div className="appLinkStores">
          <a className="appLinkBtn appLinkBtnPrimary" href={APP_STORE_URL} target="_blank" rel="noreferrer">App Store</a>
          <a className="appLinkBtn appLinkBtnGhost" href={PLAY_STORE_URL} target="_blank" rel="noreferrer">Google Play</a>
        </div>
      )}
      {params.id || params.gameId ? <small className="appLinkRef">{path}</small> : null}
    </div>
  );
}
